"use client";
import { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import ThemeLink from "@/components/link";
import { requestGetHotSearch } from "@/lib/api/search";

const hostSearch = ["联轴器", "万向节", "涨紧套", "滚珠丝", "杆直线导轨", "脚杯"];

export default function Search() {
    const [hot_search_default, setHotSearchDefault] = useState<string>("");
    const [hot_search_list, setHotSearchList] = useState<string[]>([]);

    useEffect(() => {
        const fetchHotSearch = async () => {
            try {
                const { data: { hot_search_default, hot_search_list } } = await requestGetHotSearch();
                setHotSearchDefault(hot_search_default || "");
                setHotSearchList(hot_search_list || []);
            } catch (error) {
                console.error("获取热门搜索失败:", error);
            }
        };
        fetchHotSearch();
    }, []);

    return <div className="rounded-full b-flex border-2 relative border-main h-[45px] w-[60%] pl-2">
        <input type="text" placeholder="请输入产品名称或产品型号进行搜索" defaultValue={hot_search_default}
            className="w-full bg-transparent py-2 px-4 outline-none" />
        <div
            className="c-flex rounded-[20px] cursor-pointer hover:opacity-80 duration-300 px-6 bg-main h-full text-white">
            <SearchOutlined className="mr-2 text-lg" />
            <span className="whitespace-nowrap">搜索</span>
        </div>
        <div className="absolute top-full mt-1 text-themeP text-[12px]">
            热门搜索：{
                hot_search_list.map((item, index) => {
                    return <ThemeLink href={"/"} key={index} className="px-1">
                        {item}
                    </ThemeLink>;
                })
            }
        </div>
    </div>;
}
